import type { ModuleInfo } from '../Bridge';
import { Bridge } from '../Bridge';
import { once } from '../utils';
import type { Version } from '../Version';

export type GetConversionDataResponse = { type: 'success'; data: unknown } | { type: 'failure'; error: string };

export class AppsFlyerModule {
    constructor(
        readonly bridge: Bridge,
        readonly module: ModuleInfo<'appsflyer', 0>,
    ) {}

    private request<T>(data: any): Promise<T> {
        return this.bridge.request(this.module.id, data);
    }

    /**
     * Since appsflyer@0.0
     */
    async getConversionData(): Promise<GetConversionDataResponse> {
        return this.request({ type: 'get conversion data' });
    }
}

export class AppsFlyer {
    /**
     * Creates a new instance using the provided bridge.
     */
    static create = (bridge: Bridge) => {
        const module = bridge.findModule('appsflyer', 0);
        if (module) {
            return new AppsFlyer(new AppsFlyerModule(bridge, module), module.version);
        }
        return undefined;
    };

    /**
     * Returns a shared instance.
     */
    static getInstance = once(() => {
        const bridge = Bridge.getInstance();
        if (bridge) {
            return AppsFlyer.create(bridge);
        }
        return undefined;
    });

    /** Waits for the result of the AppsFlyer conversion data. */
    readonly getConversionData: () => Promise<GetConversionDataResponse>;

    private constructor(
        readonly module: AppsFlyerModule,
        readonly version: Version,
    ) {
        this.getConversionData = module.getConversionData.bind(module);
    }
}
